// extracted by mini-css-extract-plugin
export default {"container":"bj_g","containerHidden":"bj_f5","imageWrapper":"bj_f6","title":"bj_cX","buttonWrapper":"bj_f7","button":"bj_dQ"};